import React from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {EditorPanel, EditorColumn} from '../editor-components';
import RichTextArea from '../rich-text-area/rich-text-area';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Spinner from '../spinner/spinner';

/** @class ShowPolicies
  * A component for editing the show-related policies
  * (the Privacy Policy and Terms of Service)
  * @param {Object} props - the component's properties
  */
export default class ShowPolicies extends ReactFireComponent {
  constructor(props){
    super(props);
    this.state = {}
    this.dataURL = props.dataURL + '/policies';
    this.handleTosChange = this.handleTosChange.bind(this);
    this.handlePrivacyChange = this.handlePrivacyChange.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.bindAsObject(this.dataURL, 'policies');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.unbind('policies');
  }
  /** @function handleTosChange
    * Responds to text editor events in
    * the terms of service.
    */
  handleTosChange(html) {
    firebase.database().ref(`${this.dataURL}/tos`).set(html)
  }
  /** @function handleTosChange
    * Responds to text editor events in
    * the privacy policy.
    */
  handlePrivacyChange(html) {
    firebase.database().ref(`${this.dataURL}/privacy`).set(html)
  }
  /** @function render
    * Renders the component
    */
  render() {
    if(!this.state.policies) return <Spinner />
    return (
      <EditorPanel>
        <EditorColumn>
          <div className="input-group">
            <label>Terms of Service</label>
            <RichTextArea
              name="tos"
              value={this.state.policies.tos}
              onChange={this.handleTosChange}/>
          </div>
        </EditorColumn>
        <EditorColumn>
          <div className="input-group">
            <label>Privacy Policy</label>
            <RichTextArea name="privacy"
              value={this.state.policies.privacy}
              onChange={this.handlePrivacyChange}/>
          </div>
        </EditorColumn>
      </EditorPanel>
    )
  }
}



// WEBPACK FOOTER //
// ./src/show-editor/show-policies.js